<template>
  <v-container
    v-if="authenticationMixin.checkedLogin"
    class="content pa-0"
    fluid
  >
    <v-row
      class="alternatingContentRow pa-0"
    >
    </v-row>
    <v-row
      class="alternatingContentRow my-8 py-8"
    >
      <v-col
        class="center"
        cols="12"
        lg="10"
      >
        <h1
          class="text-center"
        >
          Administratie
        </h1>
        <v-row
          justify="center"
        >
          <v-col
            cols="12"
            lg="12"
          >
            <p
              class="text-center"
            >
              Alle belangrijke administratieve documenten op één plaats.
              <br>
              We adviseren u graag via onze uitgebreide informatiebrochure.
              <br>
              Hiervoor heeft u Acrobat Reader nodig.
              U kan dit gratis <a class="secondaryLink" href="https://get.adobe.com/nl/reader/" target="_blank">downloaden</a>.
            </p>
          </v-col>
        </v-row>
      </v-col>
      <v-col
        class="center mt-5"
        cols="12"
        lg="6"
      >
        <v-row
          justify="center"
        >
          <v-col
            cols="12"
            lg="4"
          >
            <p>
              <v-btn
                block
                color="primary"
                style="cursor: default"
                tile
                size="x-large"
                @click="OpenInformatiebrochure()"
              >
                Informatiebrochure
              </v-btn>
            </p>
            <p>
              <v-row>
                <v-col
                  cols="12"
                  lg="4"
                >
                  <v-btn
                    class="mb-1"
                    block
                    color="primary"
                    tile
                    size="small"
                    @click="OpenInformatiebrochure()"
                  >
                    Lezen
                  </v-btn>
                </v-col>
                <v-col
                  cols="12"
                  lg="8"
                >
                  <v-img
                    class="pl-1"
                    :src="require(`@/assets/images/Administratie informatiebrochure thumbnail.jpg`)"
                  />
                </v-col>
              </v-row>
            </p>
          </v-col>
          <v-col
            cols="12"
            lg="4"
          >
            <p>
              <v-btn
                block
                color="primary"
                style="cursor: default"
                tile
                size="x-large"
              >
                Documenten / attesten
              </v-btn>
            </p>
            <p
              v-for="index in documentenAttesten.length"
              class="pListItem"
              :class="index === 1 ? 'mb-0' : ''"
              :key="index"
            >
              <a
                class="secondaryLink"
                @click="DownloadFile(documentenAttesten[index - 1])"
              >
                {{ documentenAttesten[index - 1].naam }}
              </a>
            </p>
            <p>
              <v-btn
                block
                color="primary"
                style="cursor: default"
                tile
                size="x-large"
              >
                Kostenraming / Facturen
              </v-btn>
            </p>
            <p
              v-for="index in kostenramingFacturen.length"
              class="pListItem"
              :class="index === 1 ? 'mb-0' : ''"
              :key="index"
            >
              <v-icon
                v-if="kostenramingFacturen[index - 1].collapsable"
                class="float-right clickAction"
                color="primary"
                @click="Collapse(kostenramingFacturen[index - 1])"
              >
                mdi-chevron-{{ kostenramingFacturen[index - 1].collapsed ? 'down' : 'up' }}
              </v-icon>
              <a
                v-if="kostenramingFacturen[index - 1].url"
                class="secondaryLink"
                @click="$router.push(kostenramingFacturen[index - 1].url)"
              >
                {{ kostenramingFacturen[index - 1].naam }}
              </a>
              <span
                v-else
                @click="Collapse(kostenramingFacturen[index - 1])"
              >
                {{ kostenramingFacturen[index - 1].naam }}
              </span>
              <template
                v-if="kostenramingFacturen[index - 1].collapsable && !kostenramingFacturen[index - 1].collapsed"
              >
                <template
                  v-for="index2 in kostenramingFacturen[index - 1].children.length"
                  :key="index2"
                >
                  <br>
                  <a
                    class="pl-5 secondaryLink"
                    @click="DownloadFactuur(kostenramingFacturen[index - 1].children[index2 - 1])"
                  >
                    {{ kostenramingFacturen[index - 1].children[index2 - 1].bestandsnaam }}
                   </a>
                </template>
              </template>
            </p>
          </v-col>
          <v-col
            cols="12"
            lg="4"
          >
            <!-- <p>
              <v-btn
                block
                color="primary"
                style="cursor: default"
                tile
                size="x-large"
              >
                Verzekeringen
              </v-btn>
            </p>
            <p
              v-for="index in verzekeringen.length"
              class="pListItem"
              :class="index === 1 ? 'mb-0' : ''"
              :key="index"
            >
              <a
                class="secondaryLink"
                :href="verzekeringen[index - 1].url"
                target="_blank"
              >
                {{ verzekeringen[index - 1].naam }}
              </a>
            </p> -->
            <p>
              <v-btn
                block
                color="primary"
                style="cursor: default"
                tile
                size="x-large"
              >
                Niet te vergeten
              </v-btn>
            </p>
            <p
              v-for="index in nietTeVergeten.length"
              class="pListItem"
              :class="index === 1 ? 'mb-0' : ''"
              :key="index"
            >
              <v-icon
                v-if="nietTeVergeten[index - 1].collapsable"
                class="float-right clickAction"
                color="primary"
                @click="Collapse(nietTeVergeten[index - 1])"
              >
                mdi-chevron-{{ nietTeVergeten[index - 1].collapsed ? 'down' : 'up' }}
              </v-icon>
              <span
                @click="Collapse(nietTeVergeten[index - 1])"
              >
                {{ nietTeVergeten[index - 1].naam }}
              </span>
              <template
                v-if="nietTeVergeten[index - 1].collapsable && !nietTeVergeten[index - 1].collapsed"
              >
                <template
                  v-for="index2 in nietTeVergeten[index - 1].children.length"
                  :key="index2"
                >
                  <br>
                  <span
                    class="pl-5"
                  >
                    {{ nietTeVergeten[index - 1].children[index2 - 1].naam }}
                  </span>
                </template>
              </template>
            </p>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import authenticationMixin from '@/mixins/authenticationMixin'
import blobMixin from '@/mixins/blobMixin'
import commonMixin from '@/mixins/commonMixin'
import constantMixin from '@/mixins/constantMixin'
import errorMixin from '@/mixins/errorMixin'
import blobService from '@/services/blobService'
import klantService from '@/services/klantService'

export default {
  name: 'AdministratieComponent',
  mixins: [
    authenticationMixin,
    blobMixin,
    commonMixin,
    constantMixin,
    errorMixin
  ],
  data () {
    return {
      documentenAttesten: [
        {
          naam: 'Bewijs van kort verlet',
          subtype: 'bewijsVanKortVerlet'
        },
        {
          naam: 'Uittreksel overlijden',
          subtype: 'uittrekselVanOverlijden'
        }
      ],
      kostenramingFacturen: [
        {
          naam: 'Kostenraming',
          url: 'Facturatie'
        },
        {
          naam: 'Facturen',
          children: [],
          collapsable: true,
          collapsed: true
        }
      ],
      nietTeVergeten: [
        {
          naam: 'Nutsvoorzieningen',
          children: [
            {
              naam: 'Gas'
            },
            {
              naam: 'Water'
            },
            {
              naam: 'Elektriciteit'
            },
            {
              naam: 'Telefoon / gsm'
            },
            {
              naam: 'Internet'
            }
          ],
          collapsable: true,
          collapsed: true
        },
        {
          naam: 'Huur / verhuur'
        },
        {
          naam: 'Nummerplaat'
        },
        {
          naam: 'Automatisch (via rijksregister)',
          children: [
            {
              naam: 'Pensioen'
            },
            {
              naam: 'Ziekenfonds'
            }
          ],
          collapsable: true,
          collapsed: true
        }
      ],
      verzekeringen: [
        {
          naam: 'Uitvaartverzekering',
          url: 'https://services.corona.be/UKP/BO/?Language=NL&ref=VERSTAP_BF&name=Verstappen%20Uitvaartzorg%20%28Geel%29'
        }
      ]
    }
  },
  mounted () {
    window.scrollTo({ top: 0, behavior: 'smooth' })
    this.AuthenticationMixin_CheckIfLoggedIn()
    blobService.Init(this)
    klantService.Init(this)
    this.GetFacturen()
  },
  methods: {
    Collapse (item) {
      if (item.collapsable) {
        item.collapsed = !item.collapsed
      }
    },
    async DownloadFactuur (factuur) {
      this.CommonMixin_Load(this.$options.name, true)
      const resp = await blobService.Download(factuur.idBlob)

      if (resp && (resp.data || resp.data !== '')) {
        this.BlobMixin_DownloadAction(factuur.bestandsnaam, null, resp.data)
      }

      this.CommonMixin_Load(this.$options.name, false)
    },
    async DownloadFile (item) {
      this.CommonMixin_Load(this.$options.name, true)
      const resp = await blobService.DownloadByBlobSearchCriteria({
        subtype: this.constantMixin.codes.facturatieEnDocBestandstype.values[item.subtype],
        type: this.constantMixin.codes.blobType.values.facturatie
      })

      if (resp && (resp.data || resp.data !== '')) {
        this.BlobMixin_DownloadAction(item.naam, null, resp.data)
      }

      this.CommonMixin_Load(this.$options.name, false)
    },
    async GetFacturen () {
      this.CommonMixin_Load(this.$options.name, true)
      const resp = await klantService.GetAdministratieFacturen()

      if (resp && (resp.data || resp.data !== '')) {
        const facturenObject = this.kostenramingFacturen.find(obj => obj.naam === 'Facturen')

        if (facturenObject) {
          facturenObject.children = resp.data
        }
      }

      this.CommonMixin_Load(this.$options.name, false)
    },
    async OpenInformatiebrochure () {
      const documentPath = (await import('@/assets/documents/Administratie informatiebrochure.pdf')).default
      window.open(documentPath, '_blank')
    }
  }
}
</script>
